import { render, staticRenderFns } from "./CarteiraTrabalho.vue?vue&type=template&id=6b05a438&"
import script from "./CarteiraTrabalho.vue?vue&type=script&lang=js&"
export * from "./CarteiraTrabalho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports